module.exports = __webpack_public_path__ + "img/54_37.b12861b4.png";